module.exports = __webpack_public_path__ + "static/thermo-df8d197bd3b1af4c014c1b0e56aa54fe.png";